import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{this.tipReason}} {{d-icon \"times-circle\"}}",{ moduleName: "discourse/components/popup-input-tip.hbs" })